'use client';

import React from 'react';
import { LineChart, Line, ResponsiveContainer, Tooltip } from 'recharts';

interface SignalSparklineProps {
  data: number[];
  signalId: string;
}

interface SparkTooltipProps {
  active?: boolean;
  payload?: { value: number }[];
}

function SparkTooltip({ active, payload }: SparkTooltipProps) {
  if (!active || !payload || !payload.length) return null;
  return (
    <div className="bg-card border border-border rounded px-2 py-1 text-2xs font-mono text-foreground shadow-lg">
      +{payload[0].value} posts/h
    </div>
  );
}

export default function SignalSparkline({ data, signalId }: SignalSparklineProps) {
  const chartData = data.map((v, i) => ({ h: i, v }));
  const isRising = data[data.length - 1] > data[0];

  return (
    <ResponsiveContainer width="100%" height={36}>
      <LineChart data={chartData} margin={{ top: 2, right: 2, left: 2, bottom: 2 }}>
        <Tooltip content={<SparkTooltip />} />
        <Line
          type="monotone"
          dataKey="v"
          stroke={isRising ? 'var(--positive)' : 'var(--muted-foreground)'}
          strokeWidth={1.5}
          dot={false}
          activeDot={{ r: 3, fill: isRising ? 'var(--positive)' : 'var(--muted-foreground)' }}
        />
      </LineChart>
    </ResponsiveContainer>
  );
}